import styled from 'styled-components'
import checkGrey from '../Login/img-login/check-circle.png'
import checkGreen from '../Login/img-login/check-circle-green.png'

export const FullPageWrapper = styled.div`
  background-color: #ffffff;
  color: #1a1a1a;
  font-family: 'Roboto', system-ui, sans-serif;

  width: 100%;
  min-height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;

  padding-top: 40px;

  @media (max-width: 480px) {
    padding-top: 24px;
  }
`

export const Box = styled.div`
  width: 100%;
  max-width: 900px;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;

  /* overrides pro PrimeReact Password ficar igual ao mock */
  .passInput.p-inputwrapper,
  .passInput .p-inputtext {
    width: 100%;
  }

  .p-inputtext {
    background: #ededed;
    border: 1px solid #e1e1e1;
    border-radius: 24px;
    height: 44px;
    padding: 0 44px 0 14px;
    font-size: 0.9rem;
    color: #1a1a1a;

    &::placeholder {
      color: #9b9b9b;
    }
  }

  .p-password {
    width: 100%;
  }

  .p-input-icon-right > svg {
    /* se o tema não estiver puxando, isso ajuda a manter o olho alinhado */
    margin-right: 8px;
  }
`

export const Logo = styled.img`
  max-height: 40px;
  width: auto;
  margin-bottom: 24px;
`

export const Title = styled.h1`
  font-size: 1.4rem;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.3;
  margin: 0 0 8px 0;
  text-align: center;
`

export const Subtitle = styled.p`
  font-size: 0.95rem;
  line-height: 1.4;
  color: #6b6b6b;
  margin: 0 0 24px 0;
  text-align: center;
  max-width: 480px;
`

export const PassLabel = styled.label`
  width: 100%;
  max-width: 800px;
  font-size: 0.9rem;
  color: #1a1a1a;
  margin: 12px 0 6px 0;
`

export const PasswordChecks = styled.ul`
  list-style: none;
  margin: 10px 0 14px 0;
  padding: 0;
  width: 100%;
  max-width: 800px;
`

export const PasswordCheckItem = styled.li<{ $ok: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ $ok }) => ($ok ? '#1a1a1a' : '#9aa0a6')};
  font-size: 0.9rem;
  margin: 6px 0;

  &:before {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    background-image: url(${({ $ok }) => ($ok ? checkGreen : checkGrey)});
    background-size: contain;
    background-repeat: no-repeat;
  }
`

export const SubmitButton = styled.button<{ disabled?: boolean }>`
  width: 100%;
  max-width: 800px;
  height: 44px;
  border: 0;
  border-radius: 24px;
  background-color: #007dc9;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    filter: brightness(0.95);
  }

  &:active {
    filter: brightness(0.9);
  }

  ${({ disabled }) =>
    disabled &&
    `
      background-color: #ccc;
      cursor: not-allowed;
      &:hover { filter: none; }
      &:active { filter: none; }
    `};

  margin-bottom: 24px;
  margin-top: 8px;
`

export const BackRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  color: #0072ce;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

export const BackIcon = styled.span`
  font-size: 0.9rem;
  line-height: 1;
`

export const BackText = styled.span`
  font-size: 0.9rem;
  line-height: 1;
`

export const ErrorText = styled.div`
  width: 100%;
  max-width: 800px;
  color: red;
  font-size: 0.85rem;
  margin-top: 4px;
`
